import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    
    background: #FFFFFF;

    box-sizing: border-box;

    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);

    z-index: 10;
    min-width: 340px;

    margin-top: 5px;
    left: ${p => p.leftOffset ? p.leftOffset + 'px' : 'unset'};
    right: ${p => p.leftOffset ? 'unset' : p.leftOffset + 'px'};

    ${p => p.inheritParent && css`
      width: 100%;
      background: #FFFFFF;
      @media screen and (min-width: 768px){
        scrollbar-width: thin;
        scrollbar-color: #E3E3E3 transparent;
      }


      /* border: 1px solid #E3E3E3; */
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      /* padding: 10px; */
      overflow-y: auto;

          /* width */
      ::-webkit-scrollbar {
        width: 4px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #A5E5C4; 
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #A5E5C4; 
      }
    `}
  `}
`;
